









import Vue from 'vue';
import Navbar from '@/components/Navbar.vue';

export default Vue.extend({
    components: {
        Navbar
    },
    data: () => ({
    //
    }),
    mounted() {
        document.title = "Billing";
    },
    computed: {
        isLoggedIn() {
            return !!this.$store.state.account;
        },
        appClasses() {
            return this.$store.state.appClasses;
        }
    }
});
